import React from 'react'
import PageTable from "../../../components/pageComponents/PageTable";
import ActionsIcons from "../../../components/atoms/ActionsIcons";
import {useManagePostRequest} from '../../../hooks/useManagePostRequest/useManagePostRequest';
import {useDescargarArchivoDeS3} from '../../../hooks/useGenerarDescargarEliminarArchivo/useDescargarArchivoDeS3';
import styled from "styled-components";

const TableFaltas = ({
                         formValues,
                         paginator,
                         setPaginator,
                         successPostCallback
                     }) => {

    const [executeManagePost] = useManagePostRequest();
    const [descargarArchivo] = useDescargarArchivoDeS3();
    const rows = formValues.Items;

    const HEADERS = [
        {col: "col-sm-2", label: "Fecha Registro"},
        {col: "col-sm-2", label: "Periodo"},
        {col: "col-sm-2", label: "Fecha Inicio"},
        {col: "col-sm-2", label: "Fecha Fin"},
        {col: "col-sm-2", label: "Estado"},
        {col: "col-sm-2", label: "Acciones"}
    ]

    const handleAperturar = async (idFaltaPeriodo) => {
        await executeManagePost("Falta/AperturarPeriodosFaltas/" + idFaltaPeriodo, null, successPostCallback, true, successPostCallback);
    }

    const handleCerrar = async (idFaltaPeriodo) => {
        await executeManagePost("Falta/CerrarPeriodosFaltas/" + idFaltaPeriodo, null, successPostCallback, true, successPostCallback);
    }

    const descargar = async (file) => {
        await descargarArchivo(file?.OriginalFileName, file?.FilePath);
    };

    return (
        <PageTable headers={HEADERS} paginator={paginator} setPaginator={setPaginator}>
            <tbody className="listar-tbody">
            {rows.map((row) => (
                <tr key={row.IdFaltaPeriodo}>
                    <td className="text-center">{row.FechaCrea}</td>
                    <td>{row.Nombre}</td>
                    <td className="text-center">{row.FechaInicio}</td>
                    <td className="text-center">{row.FechaFin}</td>
                    <td className="text-center">
                        {row.EstaBloqueado &&
                            <span class="badge badge-pill badge-danger">Bloqueado</span>
                        }&nbsp;&nbsp;&nbsp;
                        {row.Estado}
                    </td>
                    <td className="text-center">
                        <ActionsIcons>
                            {row.PuedeCerrar &&
                                <Button onClick={() =>
                                    handleCerrar(row.IdFaltaPeriodo)
                                }>
                                    Cerrar
                                </Button>
                            }

                            {row.PuedeAperturar &&
                                <Button onClick={() =>
                                    handleAperturar(row.IdFaltaPeriodo)
                                }>
                                    Aperturar
                                </Button>
                            }

                            {row.PuedeDescargarErrores &&
                                <Button onClick={() =>
                                    descargar(row.ArchivoErrores)
                                }>
                                    Descargar Log
                                </Button>
                            }

                        </ActionsIcons>
                    </td>
                </tr>
            ))}
            </tbody>
        </PageTable>
    );
}

const Button = styled.button`
    color: #ffffff;
    background: #3a87c8;
    padding: 4px 8px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    outline: none;
    &:hover {
        color: #fff;
        background-color: #0069d9;
    }
    &:focus {
        outline: none; 
    }
`;

export default TableFaltas;
